/**
 * index.js
 *
 * @Author: zhangce
 * @Date: 18/3/23 下午4:21
 */

import Affix from './Affix';

export default Affix;



// WEBPACK FOOTER //
// ./src/affix/index.js